import { Component } from "react";
import * as apiUtil from "../../../util/apiUtil";
import leadPlanetImg from "../component/leadPlanet.png";

/**
 * 리드플래닛 이벤트 페이지
 * URL: /event?evt_cd=leadplanet
 * URL (트래킹 포함): /event?evt_cd=leadplanet&ad_src={base64}
 */
class EventLeadPlanetContainer extends Component {
    constructor(props) {
        super(props);
        this.ajaxCountAdSrc = this.ajaxCountAdSrc.bind(this);
    }

    componentDidMount() {
        if (!window.sessionStorage.getItem('sessionId')) {
            window.sessionStorage.setItem('sessionId', crypto.randomUUID());
        }
        this.ajaxCountAdSrc();
    }

    ajaxCountAdSrc() {
        const { adSrc } = this.props;
        const sessionId = window.sessionStorage.getItem('sessionId');

        apiUtil.asyncRequest({
            url: `/api/common/adpath/count`,
            method: apiUtil.requestMethod.POST,
            data: {
                adSrc: adSrc || null,
                type: 'VISIT',
                sessionId,
            },
            success: () => {},
        });
    }

    render() {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', minHeight: '100vh', margin: '0', backgroundColor: '#ffffff' }}>
                <div style={{ textAlign: 'center', width: '100%', maxWidth: '500px' }}>
                    <img
                        src={leadPlanetImg}
                        alt="리드플래닛 이벤트"
                        style={{ width: '100%', maxWidth: '400px', margin: '15px auto', display: 'block', cursor: 'pointer' }}
                        onClick={() => { window.location.href = '/account/login'; }}
                    />
                    <button
                        style={{
                            display: 'block',
                            width: '100%',
                            maxWidth: '400px',
                            padding: '12px',
                            fontSize: '18px',
                            fontWeight: 'bold',
                            color: 'white',
                            background: '#5BAD5B',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            margin: '15px auto',
                            textAlign: 'center'
                        }}
                        onClick={() => { window.location.href = '/account/login'; }}
                        onMouseOver={(e) => e.target.style.background = '#4A9A4A'}
                        onMouseOut={(e) => e.target.style.background = '#5BAD5B'}
                    >
                        회원가입 바로가기
                    </button>
                </div>
            </div>
        );
    }
}

export default EventLeadPlanetContainer;
